<template>
  <div class="profile-layout sample-profile type-report">
    <sample-navbar></sample-navbar>
    <div class="wrapper report" :class="[{ 'nav-open': $sidebar.showSidebar }]">
      <notifications></notifications>
      <app-side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <mobile-menu></mobile-menu>
        <template slot="links">
          <sidebar-item
            :link="{
              name: 'About the Data',
              icon: 'help',
              path: `report-about-the-data`,
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'SWOT Summary',
              icon: 'maps_home_work',
              path: `swot-summary`,
            }"
          ></sidebar-item>
          <div v-popover.right="{ name: 'swot-analysis' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'SWOT Analysis',
                icon: 'stars',
                path: `swot-analysis`,
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'finanical-insights' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Insights',
                icon: 'developer_board',
                path: `finanical-insights`,
              }"
            ></sidebar-item>
          </div>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'COVID Impact',
              icon: 'local_hospital',
              path: `covid-impact`,
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Terms',
              icon: 'info',
              path: `terms`,
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Scoring Explained',
              icon: 'help_center',
              path: `scoring-explained`,
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Manage Inputs',
              icon: 'settings',
              path: `report-input`,
            }"
          ></sidebar-item>
        </template>
      </app-side-bar>
      <div class="main-panel">
        <div :class="{ content: !$route.meta.hideContent }">
          <div v-if="!isAboutRoute" class="content">
            <PulseLoader
              :loading="loading"
              :class="{ hide: !loading }"
              quote="Action is the foundational key to all success"
              author="Pablo Picasso"
              profession="Spanish Painter"
              img="picasso.jpg"
            ></PulseLoader>
          </div>
          <zoom-center-transition :duration="200" mode="out-in">
            <div class="row">
              <!-- your content here -->
              <router-view :headerData="headerData" v-if="!loading || isAboutRoute" />
             <!-- <PulseLoader :loading="loading" :class="{ hide: !loading }" class="pulse"></PulseLoader>-->
            </div>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}

function initSidebar() {
  document.body.classList.toggle('sidebar-mini');
}

import SampleNavbar from './SampleNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import { PulseLoader } from '@/components';
import Vuex, { mapActions } from 'vuex';
import axios from 'axios';

export default {
  components: {
    SampleNavbar,
    ContentFooter,
    MobileMenu,
    PulseLoader,
  },
  data() {
    return {
      sidebarBackgroundColor: 'grey',
      sidebarBackground: 'green',
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + '/img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      roles: [],
      expandNews: false,
      expandSingle: false,
      loading: true,
      isAboutRoute: false,
      headerData: {
        area: "Market Center-point: 10.0 Mile Radius From 2601 Market Street 17011",
        bznaics: "238220.000000",
        client_logo: null,
        client_name: null,
        developer_logo: null,
        developer_name: null,
        error: false,
        errorCode: "none",
        industry: "Plumbing, Heating, and Air-Conditioning Contractors",
        isReport: true,
        sales_class: "$1m - $2.49m",
        sector: "Construction",
        title: "Company Report"
      },
    };
  },

  methods: {
    ...mapActions({
      getCompanyReport: 'user/getCompanyReport',
      alertSuccess: 'alerts/success',
      alertError: 'alerts/error',
    }),
    async init() {
      this.loading = true;

      await this.$store.dispatch('sample/getCompanyReport').then((res) => {
        this.$store.commit('user/SET_COMPANY_REPORT', res.data);
        this.getHeaderData();
        this.loading = false;
      });
    },
    checkRoute() {

      if (this.$route.name === 'SampleCRAbouttheData')
        return true;

      return false;
    },
    getHeaderData() {
      axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/productHeader', {
          params: {
            product_id: this.report.profile_id,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.headerData = res.data;
        });
    },
  },
  updated() {
    // reinitScrollbar();
  },
  mounted() {
    // reinitScrollbar();
    // initSidebar();
    // this.getHeaderData();
    this.isAboutRoute = this.checkRoute();
    this.init();
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
      report: state => state.user.company_report
    }),
    profileId() {
      return this.$route.params.id;
    },
    companyReportSummary() {
      return this.$store.getters.companyReportSummary;
    },
  },
  watch: {
    me: {
      handler: function (val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
    // sidebarMini() {
    //   this.minimizeSidebar();
    // },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.disabled-item {
  opacity: 0.5;
  pointer-events: none;
}
.sidbar {
  .sidbar-box {
    .md-list-item-container:hover {
      background-color: #3e4345 !important;
    }

    .md-list-item-content {
      justify-content: center;
      flex-direction: column-reverse;
      &:hover,
      &:active {
        background-color: #3e4345 !important;
        .md-icon {
          color: #3b7ef1 !important;
          svg {
            fill: #3b7ef1 !important;
          }
        }
      }

      .md-icon {
        color: white !important;
        margin: 0 !important;
        svg {
          fill: white !important;
          &:hover,
          &:active {
            fill: #3b7ef1 !important;
          }
        }
      }
      p {
        color: white;
        font-size: 12px;
        text-align: center;
        line-height: 1.5;
      }
    }
  }
}
.pulse {
  height: 120px !important;
  top: 1.7rem !important;
  background: transparent !important;
}
</style>
